import Vue from 'vue'
import VueRouter from 'vue-router'
const Home = () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
const LoginView = () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
const UsersView = () => import(/* webpackChunkName: "users" */ '../views/UsersView')
const StoreView = () => import(/* webpackChunkName: "stores" */ '../views/StoreView')
const StoreDetailView = () => import(/* webpackChunkName: "store-detail" */ '../views/StoreDetailView')
const RecoverPasswordView = () => import(/* webpackChunkName: "recover-password" */ '../views/RecoverPasswordView')
const RecoverPasswordFormView = () => import(/* webpackChunkName: "recover-password-form" */ '../views/RecoverPasswordFormView')
const DeliveryView = () => import(/* webpackChunkName: "delivery" */ '../views/DeliveryView')
const DeliveryDriverDetailView = () => import(/* webpackChunkName: "delivery-driver-detail" */ '../views/DeliveryDriverDetailView')
const DeliveryDetailView = () => import(/* webpackChunkName: "delivery-detail" */ '../views/DeliveryDetailView')
const ExceptionView = () => import(/* webpackChunkName: "exceptions" */ '../views/ExceptionView')
const CreateWithdrawalView = () => import(/* webpackChunkName: "create-withdrawal" */ '../views/CreateWithDrawalView.vue')
const WithdrawalView = () => import(/* webpackChunkName: "withdrawal" */ '../views/WithdrawalView.vue')
const RegisterView = () => import(/* webpackChunkName: "register" */ '../views/RegisterView.vue')
const ShopifyIntegrationView = () => import(/* webpackChunkName: "shopify" */ '../views/ShopifyIntegrationView.vue')
const BannerManagementView = () => import(/* webpackChunkName: "banners" */ '../views/BannerManagementView.vue')
const ScannerDeliveryInStoreView = () => import(/* webpackChunkName: "scanner-delivery-in-store" */ '../views/ScannerDeliveryInStoreView.vue')

Vue.use(VueRouter)

const userData = JSON.parse(localStorage.getItem('user'))
const user = userData ? userData.user : null

const homeRoute = user && user.role === 'delivery' ? '/envios' : '/dashboard'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      isPublic: false,
      roles: ['admin', 'delivery', 'store'],
      title: user && user.role === 'delivery' ? 'Lista de Envíos' : 'Inicio'
    }
  },
  {
    path: '/banners',
    name: 'Banners',
    component: BannerManagementView,
    meta: {
      isPublic: false,
      roles: ['admin']
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/usuarios',
    name: 'Users',
    component: UsersView,
    meta: {
      isPublic: false,
      roles: ['admin']
    }
  },
  {
    path: '/tiendas',
    name: 'Stores',
    component: StoreView,
    meta: {
      isPublic: false,
      roles: ['admin']
    }
  },
  {
    path: '/excepciones',
    name: 'Exceptions',
    component: ExceptionView,
    meta: {
      isPublic: false,
      roles: ['admin']
    }
  },
  {
    path: '/tiendas/:id',
    name: 'StoreDetail',
    component: StoreDetailView,
    meta: {
      isPublic: false,
      roles: ['admin']
    }
  },
  {
    path: '/recuperar-password',
    name: 'Recover Password',
    component: RecoverPasswordView,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/recuperar-password-form/:token',
    name: 'Recover Password Form',
    component: RecoverPasswordFormView,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/envios',
    name: 'Delivery',
    component: DeliveryView,
    meta: {
      isPublic: false,
      roles: ['admin', 'store']
    }
  },
  {
    path: '/escaner-en-tienda',
    name: 'ScannerDeliveryInStore',
    component: ScannerDeliveryInStoreView,
    meta: {
      isPublic: false,
      roles: ['admin', 'delivery'],
      back: { name: 'Home' },
      title: 'Escanear en tienda'
    }
  },
  {
    path: '/envios/:id',
    name: 'DeliveryDriverDetail',
    component: DeliveryDriverDetailView,
    meta: {
      isPublic: false,
      roles: ['admin', 'delivery'],
      back: { name: 'Home' },
      title: 'Estado Envío'
    }
  },
  {
    path: '/envio/:id',
    name: 'DeliveryDetailView',
    component: DeliveryDetailView,
    meta: {
      isPublic: false,
      roles: ['admin', 'store']
    }
  },
  {
    path: '/crear-retiro',
    name: 'CreateWithdrawalView',
    component: CreateWithdrawalView,
    meta: {
      isPublic: false,
      roles: ['store']
    }
  },
  {
    path: '/configuracion-tienda',
    name: 'StoreSettings',
    component: () => import(/* webpackChunkName: "store-settings" */ '../views/StoreSettingsView.vue'),
    meta: {
      isPublic: false,
      roles: ['store']
    }
  },
  {
    path: '/retiros',
    name: 'WithdrawalView',
    component: WithdrawalView,
    meta: {
      isPublic: false,
      roles: ['admin']
    }
  },
  {
    path: '/integraciones',
    name: 'ShopifyIntegration',
    component: ShopifyIntegrationView,
    meta: {
      isPublic: false,
      roles: ['admin', 'store'],
      title: 'Integración Shopify'
    }
  }
]

if (process.env.NODE_ENV === 'development') {
  routes.push({
    path: '/ui-kit',
    name: 'UiKit',
    component: () => import(/* webpackChunkName: "ui-kit" */ '../views/UiKitView.vue'),
    meta: {
      isPublic: false,
      roles: ['admin', 'delivery', 'store'],
      title: 'UI Kit - Componentes'
    }
  })

  // Vista temporal de QA visual: side-by-side etiqueta actual (v2) vs vieja (v1)
  // con datos de prueba hardcodeados. Borrar junto con LabelPreviewView.vue
  // una vez hecha la revisión.
  routes.push({
    path: '/label-preview',
    name: 'LabelPreview',
    component: () => import(/* webpackChunkName: "label-preview" */ '../views/LabelPreviewView.vue'),
    meta: {
      isPublic: false,
      roles: ['admin', 'delivery', 'store'],
      title: 'Comparador de Etiquetas (QA)'
    }
  })
}

const router = new VueRouter({
  mode: 'history',
  routes
})
router.onError((error) => {
  if (error.name === 'ChunkLoadError' || error.message.includes('Loading chunk')) {
    window.location.reload();
  }
});
export default router
